module.exports = __webpack_public_path__ + "img/back-to-top-button-en.6281210.png";